import { Article } from '@interfaces/homepage';

export interface Organization {
  admins: GroupAdmin[];
  availableProSeats: number;
  availableStandardSeats: number;
  canViewAnalytics: boolean;
  name: string;
  paidThroughDate: string;
  ssoProLink?: string;
  ssoStandardLink?: string;
  totalProSeats: number;
  totalSeats: number;
  totalStandardSeats: number;
}

export interface Analytics {
  activeSubscribers: Stat;
  activeSubscriberGrowthByMonth: MonthlySubscribersStat[];
  reads: {
    oneMonth: ReadershipMetricsStat;
    fourMonths: ReadershipMetricsStat;
  };
  topArticles: {
    oneMonth: {
      articles: Article[];
    };
    fourMonths: {
      articles: Article[];
    };
  };
  proUpgradeUserRequests: Stat;
}

export interface ReadershipMetricsStat {
  articlesRead: Stat;
  newslettersRead: Stat;
}

export interface MonthlySubscribersStat {
  month: string;
  activeSubscribers: number;
}

export interface User {
  email: string;
  id?: number;
  name: string;
  type: UserType;
}

export interface GroupUser extends User {
  corporateSubscriptionId?: number;
  accessLevel: number;
}

export interface GroupAdmin extends User {
  groupAdminId?: number;
  organizationId?: number;
}

export enum UserOperationType {
  CREATE = 'CREATE',
  UPDATE = 'UPDATE',
  REACTIVATE = 'REACTIVATE',
}

export enum UserType {
  Admin = 'admin',
  Active = 'active',
  Archived = 'archived',
}

export type FormValues = Pick<User, 'name' | 'email'> & {
  pro?: boolean;
};

export enum FormActionType {
  CREATE_USER = 'CREATE_USER',
  CREATE_ADMIN = 'CREATE_ADMIN',
  UPDATE_USER = 'UPDATE_USER',
  UPDATE_ADMIN = 'UPDATE_ADMIN',
  REMOVE_ADMIN = 'REMOVE_ADMIN',
  DEACTIVATE_USER = 'DEACTIVATE_USER',
  REACTIVATE_USER = 'REACTIVATE_USER',
}

export enum FormButtonType {
  PRIMARY = 'PRIMARY',
  SECONDARY = 'SECONDARY',
}

export enum NavOption {
  Account = 'account',
  Admins = 'admins',
  Analytics = 'analytics',
  Users = 'users',
}

export interface NavItem {
  id: NavOption;
  name: string;
}

export const NAV_OPTIONS: NavItem[] = [
  { id: NavOption.Account, name: 'Account' },
  { id: NavOption.Admins, name: 'Admins' },
  { id: NavOption.Users, name: 'Users' },
  { id: NavOption.Analytics, name: 'Analytics' },
];

export interface PeriodOption {
  label: string;
  value: string;
}

export const PERIOD_OPTIONS: PeriodOption[] = [
  { label: 'Last 30 days', value: 'oneMonth' },
  { label: 'Last 4 months', value: 'fourMonths' },
];

export const HEADER_OFFSET = 85;

export type SeatUpdateResult = {
  availableProSeats: number;
  availableStandardSeats: number;
};

export interface PaginatedUsers {
  users: GroupUser[];
  currentPage: number;
  hasNextPage: boolean;
}

export interface ErrorResponse {
  message: string;
}

export interface UsersParams {
  pageParam: number;
  searchTerm?: string;
}

export interface Stat {
  name: string;
  value: number;
}
